<template>
  <v-highlight
    :product="product"
    :trailer-mode="TrailerMode.BILLBOARD"
    class="c-highlight--billboard"
  >
    <h3 class="o-typography__headline2 u-text-transform-none u-bold">
      {{ product.title }}
    </h3>
    <div class="c-highlight__info">
      <v-badge
        :product="product"
        class="c-highlight__badge"
        :counting="isFuture"
      ></v-badge>
      <p class="c-highlight__meta u-color-secondary o-typography__subtitle1">
        {{ product | meta(['year', 'rating', 'duration']) }}
      </p>
    </div>
    <p class="o-typography__body1 o-typography__label u-ellipsis-2-lines">
      {{ product.lead }}
    </p>
    <template #buttons>
      <v-play-product
        v-if="isPlayable || isFuture"
        :product="product"
        :autoplay-redirect="true"
      ></v-play-product>
      <v-favourite-toggle
        v-if="isFavouritable"
        :product="product"
      ></v-favourite-toggle>
      <v-product-redirect :product="product"></v-product-redirect>
    </template>
  </v-highlight>
</template>
<script>
  import { VBadge, VFavouriteToggle, VHighlight, VPlayProduct, VProductRedirect } from '@/index/shared/components';
  import { meta, truncate } from '@/index/shared/filters';
  import { productMixin } from '@/index/shared/mixins';
  import { randomProductMixin } from '@/index/components/section/mixins';
  import { TrailerMode } from '@/shared/enums';

  export default {
    components: {
      VBadge,
      VHighlight,
      VFavouriteToggle,
      VProductRedirect,
      VPlayProduct,
    },
    enums: {
      TrailerMode,
    },
    filters: {
      meta,
      truncate,
    },
    mixins: [
      productMixin,
      randomProductMixin,
    ],
  };
</script>
